<template>
  <div v-show="show" class="today">
    <div class="weather">
      <img
        v-if="weather.weatherImage"
        :src="require('@/assets/img/weather/' + weather.weatherImage)"
      />
      <span style="margin-right: 8px">{{ weather.info }}</span>
      <span>{{ weather.temperature }}℃</span>
    </div>
    <!-- <div class="nowadays_line"></div>
    <div class="nowadays">
      <span class="nowadays_1">{{ currentTime.date }}</span>
      <span class="nowadays_2">{{ currentTime.day }}</span>
      <span class="nowadays_3">{{ currentTime.time }}</span>
    </div> -->
  </div>
</template>

<script>
    import { getLargeScreenWeatherData } from "@/api/third";

export default {
  name: "",
  data() {
    return {
      show: false,
      // 当前时间
      currentTime: {
        timer: null,
        date: null,
        time: null,
        day: null,
      },
      // 天气信息
      weather: {
        info: null,
        temperature: null,
        weatherImage: null,
        weatherList: [
          "晴",
          "多云",
          "阴",
          "雾",
          "冰雹",
          "沙尘",
          "雷阵雨",
          "阵雨",
          "小雨",
          "中雨",
          "大雨",
          "暴雨",
          "雨夹雪",
          "晨雪",
          "小雪",
          "中雪",
          "大雪",
          "暴雪",
          "夜晚晴",
          "夜晚多云",
          "无信息",
          "苦脸",
        ],
        weatherImages: [
          "icon-qing.png",
          "icon-duoyun.png",
          "icon-yintian.png",
          "icon-wu.png",
          "icon-bingbao.png",
          "icon-shachen.png",
          "icon-leizhenyu.png",
          "icon-zhenyu.png",
          "icon-xiaoyu.png",
          "icon-zhongyu.png",
          "icon-dayu.png",
          "icon-baoyu.png",
          "icon-yujiaxue.png",
          "icon-chenxue.png",
          "icon-xiaoxue.png",
          "icon-zhongxue.png",
          "icon-daxue.png",
          "icon-baoxue.png",
          "icon-yewanqing.png",
          "icon-yewanduoyun.png",
          "icon-wuxinxi.png",
          "icon-kulian.png",
        ],
      },
    };
  },
  created() {
    let that = this;
    this.loadWeatherData();
    //时间定时刷新
    this.currentTime.timer = setInterval(function () {
      that.handleCurrentTimeRefresh();
    }, 1000);
  },
  beforeDestroy() {
    if (this.currentTime.timer) clearTimeout(this.currentTime.timer);
  },
  methods: {
    // 加载天气数据
    loadWeatherData() {
      let that = this;
      getLargeScreenWeatherData()
        .then((result) => {
          console.log("weather"+result);
          that.weather.info = result.data.realtime.weather.info;
          that.weather.temperature = result.data.realtime.weather.temperature;
          that.weather.weatherImage =
            that.weather.weatherImages[
              that.weather.weatherList.indexOf(that.weather.info)
            ];
        })
        .then(() => {
          that.show = true;
        });
    },
    // 定时刷新当前时间
    handleCurrentTimeRefresh() {
      let date = new Date();
      var weeks = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      this.currentTime.date =
        date.getFullYear() +
        "年" +
        (date.getMonth() + 1) +
        "月" +
        date.getDate() +
        "日";
      let hour = date.getHours();
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      this.currentTime.time = hour + ":" + minutes;
      this.currentTime.day = weeks[date.getDay()];
    },
  },
};
</script>
<style lang='scss' scoped>
.today {
  width: 100%;
  padding-right: 33px;
  box-sizing: border-box;
}

.nowadays {
  float: right;
  color: #ffffff;
  font-size: 0;
  margin-top: 22px;
}

.nowadays_1 {
  font-size: 14px;
  margin-right: 12px;
}

.nowadays_2 {
  font-size: 15px;
  margin-right: 12px;
}

.nowadays_3 {
  font-size: 16px;
  font-family: myfont;
}

.nowadays_line {
  float: right;
  width: 1px;
  height: 19px;
  background: rgba(255, 255, 255, 0.6);
  margin: 20px;
  margin-bottom: 0;
}

.weather {
  float: right;
  font-size: 0;
  margin-bottom: 25px;
}

.weather > img {
  width: 50px;
  height: 50px;
  margin-right: 7px;
}

.weather > span {
  font-size: 30px;
  color: #39a6e4;
  position: relative;
  top: -15px;
}
</style>